import React from 'react';

import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import * as routes from '../../config/routes';
import * as constants from '../../config/constants';


const socialLoginButtons = (props) => {
  let isSignup = '';
  if (props.isSignup) {
    isSignup = '?isSignup=1';
  }
  return (
    <React.Fragment>
      <Grid container>
        <Grid item md={12} xs={12} sm={12}>
          <GoogleLogin
            clientId={constants.GOOGLE_APP_ID}
            disabledStyle
            prompt="select_account"
            autoLoad={false}
            onSuccess={props.responseGoogle}
            onFailure={props.responseGoogle}
            render={renderProps => (
              <Button variant="contained" color="default" style={{ backgroundColor: '#db3236', color: '#fff' }} onClick={renderProps.onClick}>
                <Icon className="fab fa-google loginBtnIcon" style={{ fontSize: '18px', marginRight: '6px' }} />
                Login with Google
              </Button>
            )}
          />
        </Grid>
      </Grid>
      <br />
      <Grid container>
        <Grid item md={12} xs={12} sm={12}>
          <FacebookLogin
            appId={constants.FB_APP_ID}
            autoLoad={false}
            fields="name,email,picture"
            scope="public_profile,email"
            version="2.3"
            disabledStyle
            returnScopes
            authType="reauthenticate"
            redirectUri={`https://${window.location.host}${routes.FB_CALLBACK}${isSignup}`}
            callback={props.responseFacebook}
            render={renderProps => (
              <Button variant="contained" color="default" style={{ backgroundColor: '#3B5998', color: '#fff' }} onClick={renderProps.onClick}>
                <Icon className="fab fa-facebook-f loginBtnIcon" style={{ fontSize: '18px', marginRight: '6px' }} />
                Login with Facebook
              </Button>
            )}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default socialLoginButtons;



// WEBPACK FOOTER //
// ./src/auth/components/SocialLoginButtons.js